import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface DownloadSignatureStoreState {
  signatureIDs: '';
  sigApplicableProdDetails:'';
}

export default {
  state:{
    signatureIDs: '',
    sigApplicableProdDetails:'',
  },
  mutations:{
    setSignatureIDs(state, payload) {
      state.signatureIDs = payload;
    },
    setSigApplicableProdDetails(state, payload) {
      state.sigApplicableProdDetails = payload;
    },
  },
  actions:{
    async getSignatureFiles(context: ActionContext<DownloadSignatureStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'downloads/get-signature-files';
      return ApiServiceWrapper.get(endpoint);
    },
  },
  getters:{
    getSignatureIDs(state) {
      return state.signatureIDs;
    },
    getSigApplicableProdDetails(state) {
      return state.sigApplicableProdDetails;
    },
  },
  namespaced: true,
}as Module<DownloadSignatureStoreState, RootStoreState>;
